import { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { List, Text, useTheme } from 'react-native-paper';

import { rippleOnSurface } from '@/theme';

interface InfoListItemProps {
  readonly title: string;
  readonly subtitle?: string | null;
  readonly tertiaryText?: string | null;
  readonly onPress?: () => void;
}

const Description = ({
  subtitle,
  tertiaryText,
}: {
  subtitle?: string | null;
  tertiaryText?: string | null;
}) => {
  const theme = useTheme();

  return (
    <View>
      {subtitle ? (
        <Text variant="bodySmall" style={{ color: theme.colors.secondary }} numberOfLines={1}>
          {subtitle}
        </Text>
      ) : null}
      {tertiaryText ? (
        <Text variant="bodySmall" style={{ color: theme.colors.outline }} numberOfLines={1}>
          {tertiaryText}
        </Text>
      ) : null}
    </View>
  );
};

const InfoListItemBase = ({ title, subtitle, tertiaryText, onPress }: InfoListItemProps) => {
  const theme = useTheme();

  return (
    <List.Item
      accessibilityLabel={title}
      accessibilityRole={onPress ? 'button' : undefined}
      containerStyle={styles.itemContainer}
      contentStyle={styles.itemContent}
      rippleColor={rippleOnSurface}
      style={styles.item}
      title={title}
      titleStyle={{ color: theme.colors.onSurface }}
      description={() => <Description subtitle={subtitle} tertiaryText={tertiaryText} />}
      onPress={onPress}
    />
  );
};

const styles = StyleSheet.create({
  item: {
    flex: 1,
    margin: 0,
    padding: 0,
  },
  itemContainer: {
    marginVertical: 0,
  },
  itemContent: {
    justifyContent: 'center',
    paddingHorizontal: 16,
  },
});

export const InfoListItem = memo(InfoListItemBase);
